import React from "react";
import ReactDOM from "react-dom";
import DashApp from "./dashApp";
import LogRocket from 'logrocket';
import ClearCache from "react-clear-cache";
// import * as serviceWorker from "./serviceWorker";
import { ToastContainer } from "react-toastify";
import "antd/dist/antd.css";
import "./static/css/common.css";
import "./static/css/add.css";
import "./static/css/userManagement.css";
import "react-toastify/dist/ReactToastify.min.css";

LogRocket.init('whn5fi/mover-inventory');


ReactDOM.render(
	<ClearCache>
		{({ isLatestVersion, emptyCacheStorage }) => (
			<>
				{!isLatestVersion && (
					<div style={{
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						backgroundColor: '#1890ff',
						color: 'white',
						padding: '10px 20px',
						textAlign: 'center',
						zIndex: 9999,
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						gap: '15px'
					}}>
						<span>A new version is available!</span>
						<button
							onClick={(e) => {
								e.preventDefault();
								emptyCacheStorage();
							}}
							style={{
								backgroundColor: 'white',
								color: '#1890ff',
								border: 'none',
								padding: '5px 15px',
								borderRadius: '4px',
								cursor: 'pointer',
								fontWeight: 'bold'
							}}
						>
							Update Now
						</button>
					</div>
				)}
				<DashApp />
				<ToastContainer newestOnTop={true} hideProgressBar={true} theme='light' autoClose={false} />
			</>
		)}
	</ClearCache>,
	document.getElementById("root")
);

// serviceWorker.unregister();
